import { initDietCalculation } from './react/diet-calculation/DietCalculation';

document.addEventListener('DOMContentLoaded', () => {
    const defaultContainer = document.getElementById('diet-calculation-wrapper');

    const { saveProductApiEndpoint, translations, defaultData, cartLink } = JSON.parse(window.__INITIAL_STATE);

    initDietCalculation(defaultContainer, {
        defaultData: JSON.parse(defaultData),
        saveProductApiEndpoint,
        translations,
        cartLink,
    });
});
